// Module
var code = "<h2 id=\"mobile-application\">Mobile Application</h2> <p>Find out how easy it is to manage your account on the go.</p> ";
// Exports
export default code;